import { isPlainObject } from 'shared/utils/object';

/**
 * What an issue change keeps in the HTTP queue: the API body next to the
 * change's `uniqueId` (never sent to the API), so its outcome reaches the page
 * that waits for it.
 */
export interface IssueRequestData<TBody = unknown> {
  body?: TBody;
  uniqueId: string;
  /** The changed issue, for the outcome of a delete. */
  issueId?: string;
}

function isIssueRequestData(data: unknown): data is IssueRequestData {
  return isPlainObject(data) && typeof data.uniqueId === 'string';
}

/** The change's correlation of a queued issue request; none for requests queued before PT-7133. */
export function issueRequestDataOf(request: { data?: unknown }): Partial<IssueRequestData> {
  return isIssueRequestData(request.data) ? request.data : {};
}

/**
 * The API body of a queued issue request. Migration of queued entries:
 * requests stored in IndexedDB before PT-7133 keep the body itself as their data.
 */
export function issueRequestBody(data: unknown): unknown {
  return isIssueRequestData(data) ? data.body : data;
}
